import 'sticksy';

const sidebarInner = document.querySelector('.sidebar-inner');

if (sidebarInner) {
	const wpadminbar = document.getElementById('wpadminbar');
	const stickySidebar = new Sticksy(sidebarInner, {
		topSpacing: wpadminbar ? Math.round(wpadminbar.offsetHeight + 40) : 40,
		listen: true,
	});

	stickySidebar.onStateChanged = function (state) {
		stickySidebar.nodeRef.classList.toggle('is-fixed', state === 'fixed')
	}
}